import path from 'ramda/src/path'
import prop from 'ramda/src/prop'
import isNil from 'ramda/src/isNil'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { UPDATE_PROFILE } from 'root/src/shared/descriptions/endpoints/endpointIds'
import uploadFile from 'root/src/client/util/uploadFile'
import updateProfile from 'root/src/client/logic/profile/actions/updateProfile'
import mixpanel from 'root/src/client/logic/analytics/mixpanel'
import { mixpanelEvents } from 'root/src/shared/constants/mixpanel'
import { events } from 'root/src/shared/constants/analytics'
import analyticsSendItem from 'root/src/client/logic/analytics/util/analyticsSendItem'
import userIdSelector from 'root/src/client/logic/auth/selectors/userIdSelector'

const getImage = async (formData, dispatch) => {
	const image = prop('image', formData)
	if (!image) return undefined
	const {
		x = 0,
		y = 0,
		zoom = 1,
		xPixels = 0,
		yPixels = 0,
		height = 10000, // so big as it expands to max dimensions keeping correct ratio
		width = 10000, // so big as it expands to max dimensions keeping correct ratio
	} = path(['image'], formData)

	return !isNil(image.url)
		? image
		: {
			url: await uploadFile(path(['image', 'file'], formData), dispatch),
			x,
			y,
			zoom,
			xPixels,
			yPixels,
			height,
			width,
		}
}

export default formData => async (dispatch, getState) => {
	const state = await getState()
	const image = await getImage(formData, dispatch)
	const payload = { ...formData, image }
	const res = await dispatch(apiRequest(UPDATE_PROFILE, payload))
	dispatch(updateProfile(res.body))
	mixpanel.track(mixpanelEvents.profileEdit)
	const userId = userIdSelector(state)
	analyticsSendItem(events.profileEdit, userId)
}
